/*************************************************/
/* Slider                                        */
/*************************************************/
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

Swiper.use([Navigation, Pagination]);
export function slider() {
    const articleSliderSelector = ".articles-list__container-news.swiper";
    const casesSliderSelector = ".articles-list__container-cases.swiper";
    const imageSliderSelector = ".image-slider__slider.swiper";
    const videoSliderSelector = ".video-slider__slider.swiper";

    const handleSlideChangeTransitionEnd = function (swiper) {
        //Fix the tabindex for accebility
        swiper.el
            .querySelectorAll(" .swiper-slide > a")
            .forEach((slide) => {
                slide.setAttribute("tabindex", "-1");
            });

        const activeSlide = swiper.el.querySelector(" .swiper-slide-active > a"
        );
        if (activeSlide != null) {
            activeSlide.setAttribute("tabindex", "0");
        }
    };

    const handleSlideChange = function () {
        //Makes sure that the lazyloaded image on the duplicate slide has the right class so it doesnt show up as grey
        var nextDuplicateSlide = document.querySelector(".swiper-slide-duplicate.swiper-slide-next");
        if (nextDuplicateSlide != null) {
            var unloadedSlideImage = nextDuplicateSlide.querySelector("img.lazyloading");
            if (unloadedSlideImage != null) {
                unloadedSlideImage.classList.replace("lazyloading", "lazyloaded");
            }
        }
    }

    const init = function () {
        // Articles Slider
        const ArticlesSlider = [];
        const ArticlesSliderElements = document.querySelectorAll(articleSliderSelector);
        if (ArticlesSliderElements) {
            ArticlesSliderElements.forEach(slider => {
                ArticlesSlider.push(new Swiper(slider, {
                    speed: 500,
                    loop: false,
                    slidesPerView: 1,
                    spaceBetween: 15,
                    navigation: {
                        nextEl: '#' + slider.dataset.componentId + " .articles-list__button-next",
                        prevEl: '#' + slider.dataset.componentId + " .articles-list__button-prev",
                    },
                    pagination: {
                        el: '#' + slider.dataset.componentId + " .swiper-pagination",
                    },
                    breakpoints: {
                        992: {
                            slidesPerView: 2.2,
                            spaceBetween: 45,
                        }
                    },
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        }
                    }
                }));
            })
        }

        // Cases Slider
        const CasesSlider = [];
        const CasesSliderElements = document.querySelectorAll(casesSliderSelector);
        if (CasesSliderElements) {
            CasesSliderElements.forEach(slider => {
                CasesSlider.push(new Swiper(slider, {
                    speed: 500,
                    loop: false,
                    slidesPerView: 1.5,
                    spaceBetween: 15,
                    navigation: {
                        nextEl: '#' + slider.dataset.componentId + " .articles-list__button-next",
                        prevEl: '#' + slider.dataset.componentId + " .articles-list__button-prev",
                    },
                    breakpoints: {
                        992: {
                            slidesPerView: 3,
                            spaceBetween: 45,
                        }
                    },
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        }
                    }
                }));
            })
        }

        // Image Slider
        const imageSlider = [];
        const imageSliderElements = document.querySelectorAll(imageSliderSelector);
        if (imageSliderElements) {
            imageSliderElements.forEach(slider => {

                imageSlider.push(new Swiper(slider, {
                    effect: "coverflow",
                    slidesPerView: 1.15,
                    spaceBetween: 15,
                    pagination: {
                        el: '#' + slider.dataset.componentId + " .swiper-pagination",
                    },
                    navigation: {
                        nextEl: '#' + slider.dataset.componentId + " .image-slider__button-next",
                        prevEl: '#' + slider.dataset.componentId + " .image-slider__button-prev",
                    },
                    breakpoints: {
                        768: {
                            spaceBetween: 30,
                        }
                    },
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        }
                    }
                }));
            })
        }

        // video Slider
        const videoSlider = [];
        const videoSliderElements = document.querySelectorAll(videoSliderSelector);
        if (videoSliderElements) {
            videoSliderElements.forEach(slider => {

                videoSlider.push(new Swiper(slider, {
                    effect: "coverflow",
                    slidesPerView: 1.15,
                    spaceBetween: 15,
                    pagination: {
                        el: '#' + slider.dataset.componentId + " .swiper-pagination",
                        // dynamicBullets: true,
                        clickable: true,
                    },
                    navigation: {
                        nextEl: '#' + slider.dataset.componentId + " .video-slider__button-next",
                        prevEl: '#' + slider.dataset.componentId + " .video-slider__button-prev",
                    },
                    breakpoints: {
                        768: {
                            spaceBetween: 30,
                            slidesPerView: 2.2,
                        }
                    },
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        }
                    }
                }));
            })
        }
    }

    init();
}
